import type { GetApiV1RequestListParams } from '@1webit/cvs-api-scheme/models';
import { queryOptions } from '@tanstack/react-query';

import { getResponse, queryParams } from '@/utils';

/**
 * Gets beach penalty details
 */
export const getApiV1RequestFormBeachFineRequestId = (requestId: number) => queryOptions({
  queryKey: ['getApiV1RequestFormBeachFineRequestId', requestId],
  queryFn: () => getResponse('getApiV1RequestFormBeachFineRequestId', requestId),
});

/**
 * Gets beach tournament application
 */
export const getApiV1RequestFormBeachTournamentApplicationRequestId = (requestId: number) => queryOptions({
  queryKey: ['getApiV1RequestFormBeachTournamentApplicationRequestId', requestId],
  queryFn: () => getResponse('getApiV1RequestFormBeachTournamentApplicationRequestId', requestId),
});

/**
 * Gets beach tournament cancellation
 */
export const getApiV1RequestFormBeachCancelApplicationRequestId = (requestId: number) => queryOptions({
  queryKey: ['getApiV1RequestFormBeachCancelApplicationRequestId', requestId],
  queryFn: () => getResponse('getApiV1RequestFormBeachCancelApplicationRequestId', requestId),
});

/**
 * Gets beach hosting request
 */
export const getApiV1RequestFormBeachHostingRequestRequestId = (requestId: number) => queryOptions({
  queryKey: ['getApiV1RequestFormBeachHostingRequestRequestId', requestId],
  queryFn: () => getResponse('getApiV1RequestFormBeachHostingRequestRequestId', requestId),
});

export const getApiV1RequestFormChangeInfoRequestId = (requestId: number) => queryOptions({
  queryKey: ['getApiV1RequestFormChangeInfoRequestId', requestId],
  queryFn: () => getResponse('getApiV1RequestFormChangeInfoRequestId', requestId),
});

export const getApiV1RequestTypes = queryOptions({
  queryKey: ['getApiV1RequestTypes'],
  queryFn: () => getResponse('getApiV1RequestTypes'),
});

export const getApiV1RequestFormCompetitionCodes = queryOptions({
  queryKey: ['getApiV1RequestFormCompetitionCodes'],
  queryFn: () => getResponse('getApiV1RequestFormCompetitionCodes'),
});

export const getApiV1RequestFormAvailableGroupsCompetitionId = (competitionId: number) => queryOptions({
  queryKey: ['getApiV1RequestFormAvailableGroupsCompetitionId', competitionId],
  queryFn: () => getResponse('getApiV1RequestFormAvailableGroupsCompetitionId', competitionId),
});

export const getApiV1RequestFormAvailableNumbersGroupId = (groupId: number) => queryOptions({
  queryKey: ['getApiV1RequestFormAvailableNumbersGroupId', groupId],
  queryFn: () => getResponse('getApiV1RequestFormAvailableNumbersGroupId', groupId),
});

export const getApiV1RequestFormMatchesGroupIdTeamId = (groupId: number, teamId: number) => queryOptions({
  queryKey: ['getApiV1RequestFormMatchesGroupIdTeamId', groupId, teamId],
  queryFn: () => getResponse('getApiV1RequestFormMatchesGroupIdTeamId', groupId, teamId),
});

export const getApiV1RequestFollowersRequestId = (requestId: number) => queryOptions({
  queryKey: ['getApiV1RequestFollowersRequestId', requestId],
  queryFn: () => getResponse('getApiV1RequestFollowersRequestId', requestId),
});

export const getApiV1RequestFormBeachCancelApplicationTournamentIdPairs = (tournamentId: number) => queryOptions({
  queryKey: ['getApiV1RequestFormBeachCancelApplicationTournamentIdPairs', tournamentId],
  queryFn: () => getResponse('getApiV1RequestFormBeachCancelApplicationTournamentIdPairs', tournamentId),
});

export const getApiV1RequestList = (params?: GetApiV1RequestListParams) => queryOptions({
  queryKey: ['getApiV1RequestList', params],
  queryFn: () => getResponse('getApiV1RequestList', params),
});

export const getApiV1RequestFormTeamsToExcludeUserId = (userId: number) => queryOptions({
  queryKey: ['getApiV1RequestFormTeamsToExcludeUserId', userId],
  queryFn: () => getResponse('getApiV1RequestFormTeamsToExcludeUserId', userId),
});

export const getApiV1RequestTypesList = queryOptions({
  queryKey: ['getApiV1RequestTypesList'],
  queryFn: () => getResponse('getApiV1RequestTypesList'),
});

export const getApiV1RequestMyRequests = queryOptions({
  queryKey: ['getApiV1RequestMyRequests'],
  queryFn: () => getResponse('getApiV1RequestMyRequests'),
});

export const getApiV1RequestCompetitionManagementRequestType = (requestType: number, competitionCode?: string) => queryOptions({
  queryKey: ['getApiV1RequestCompetitionManagementRequestType', requestType, competitionCode],
  queryFn: () => getResponse('getApiV1RequestCompetitionManagementRequestType', requestType, queryParams({ competitionCode })),
});

export const getApiV1RequestFormToleranceGroupId = (groupId: number) => queryOptions({
  queryKey: ['getApiV1RequestFormToleranceGroupId', groupId],
  queryFn: () => getResponse('getApiV1RequestFormToleranceGroupId', groupId),
});

export const getApiV1RequestGetTypeRequestId = (requestId: number) => queryOptions({
  queryKey: ['getApiV1RequestGetTypeRequestId', requestId],
  queryFn: () => getResponse('getApiV1RequestGetTypeRequestId', requestId),
});

export const getApiV1RequestUserRights = (requestType: number) => queryOptions({
  queryKey: ['getApiV1RequestUserRights', requestType],
  queryFn: () => getResponse('getApiV1RequestUserRights', { itemId: requestType }),
});
